function moduleForm() {
	/** @type {NodeListOf<HTMLElement>} */
	const modules = document.querySelectorAll('.module.form');
	if (!modules.length) return;

	function triggerFileInput(trigger) {
		const wrapper = trigger.closest('.js-file-upload');
		if (!wrapper) return;
		wrapper.querySelector('input[type="file"]')?.click();
	}

	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('.js-file-trigger');
		if (trigger) triggerFileInput(trigger);
	});

	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Enter' && e.key !== ' ') return;
		const trigger = e.target.closest('.js-file-trigger');
		if (!trigger) return;
		e.preventDefault();
		triggerFileInput(trigger);
	});

	document.addEventListener('change', (e) => {
		const input = e.target;
		if (!input.matches('input[type="file"]')) return;

		const wrapper = input.closest('.js-file-upload');
		if (!wrapper) return;

		const fileNameEl = wrapper.querySelector('.file-name');
		if (!fileNameEl) return;

		fileNameEl.textContent = input.files?.length ? input.files[0].name : '';
	});
}
